import React, { forwardRef } from 'react'
import { MoreHorizTwoTone } from '@mui/icons-material'
import { IconMenu } from '../../'
import { ALLOW_BOOKMARKS_GROUP, ALLOW_PLAYLISTS_GROUP } from '../../user-group-policy/permissions'
import { useGroup } from '../../../hooks'
import useFreeAccountCta from '../../../hooks/useFreeAccountCta'
import { useDisplayAddToPlaylist } from '../../../hooks/useDisplayAddToPlaylist'

const MoreActions = forwardRef(
  ({ onAddToPlaylist, onBookmark, bookmarked, ...props }, ref) => {
    const { isInGroup } = useGroup()
    const displayAddToPlaylist = useDisplayAddToPlaylist()

    const options = [
      ...(isInGroup(ALLOW_PLAYLISTS_GROUP) && displayAddToPlaylist ? [{ label: 'Add to playlist', value: 'addtoplaylist' }] : []),
      ...(isInGroup(ALLOW_BOOKMARKS_GROUP) ? [{ label: bookmarked ? 'Bookmarked' : 'Add to bookmarks', value: 'bookmark' }] : [{ label: bookmarked ? 'Bookmarked' : 'Add to bookmarks', value: 'noAuthBookmark' }])
    ]
    const { openFreeAccountModalForAddContentToBookmark } = useFreeAccountCta()

    const handleChange = value => {
      switch (value) {
        case 'bookmark' : {
          onBookmark()
          break
        }
        case 'addtoplaylist' : {
          onAddToPlaylist()
          break
        }
        case 'noAuthBookmark' : {
          openFreeAccountModalForAddContentToBookmark()
          break
        }
      }
    }

    return (
      <IconMenu
        icon={<MoreHorizTwoTone />}
        options={options}
        onChange={handleChange}
        id='more-actions'
        aria-label='more actions'
        ref={ref}
        {...props}
      />
    )
  }
)

MoreActions.displayName = 'MoreActions'

export default MoreActions
